import React, { useEffect, useState } from "react";
import { Box, Button, Link, Card as MuiCard } from "@alpha/ui-lib/ui/external";
import { makeStyles } from "@alpha/ui-lib/theme";
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { faArrowRight, faChevronDown, faChevronUp, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from "@alpha/ui-lib/ui/Typography";
import { ActionButton } from "@alpha/ui-lib/ui/button/ActionButton";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useQuery } from "react-query";
import MigrationCentreService from "services/MigrationCentre/migrationCentre.service";
import useAlphaSnackbar from "hooks/useAlphaSnackbar";
import useLog from "hooks/useLog";
import BeneficiariesService from "services/Beneficiaries/beneficiaries.service";
import { TMigrationFaqsResponse } from "models/migrationCentre";
import { useTranslation } from "react-i18next";

const Card = MuiCard as React.FC<React.ComponentProps<typeof MuiCard>>;

export const useStyles = makeStyles(
  () => ({
    faq: {
      padding: '16px',
      overflow: 'hidden',
      minWidth: 0,
    },
    accordionContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      marginTop: '16px',
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: '0px',
        height: '48px',
      },
      '& .MuiAccordion-root.Mui-expanded': {
        margin: '0px',
      }
    },
    }),
    { name: 'FAQ' },
  );

const FAQ: React.FC = () => {
  const classes = useStyles();
  const sb = useAlphaSnackbar();
  const { logError } = useLog();
  const [faqs, setFaqs] = useState<TMigrationFaqsResponse>([]);
  const { t } = useTranslation();

  async function getMigrationFaqs() {
    try {
      setFaqs(await MigrationCentreService.getMigrationFaqs());
    } catch (e) {
      sb.trigger(e.response?.data?.error || 'ERROR');
      console.error({ action: 'Error getting migration FAQs.' });
    }
  }

  useEffect(() => {
    getMigrationFaqs();
  }, []);

  return (
    <>
    <Card className={classes.faq}>
      <Typography variant="h3">{t('migration_faqs')}</Typography>
        <div>{t('find_answers_to_common_questions_about_the_migration_to_corpay')}</div>
      <Box className={classes.accordionContainer}>
      {faqs.map((faq) => (
        <>
          <Accordion key={faq.title} sx={{ border: '1px solid #EAEAEA', borderRadius: '5px', boxShadow: 'none' }}>
            <AccordionSummary
              key={faq.title}
              expandIcon={<FontAwesomeIcon icon={faChevronDown as IconProp} />}
            >
              <Typography variant="body1" style={{ fontWeight: 600, color: '#1E8777' }}>{faq.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{faq.description}</Typography>
            </AccordionDetails>
          </Accordion>
        </>
      ))}
      </Box>
    </Card>
    </>
  )
}

export default FAQ;